module.exports = __webpack_public_path__ + "static/gamak-55c0476cbf4bc0fcb44089e83f5a3983.webp";